export type PurchaseOrderIdentifiers = {
  project_po_number: string | null;
  po_number: string;
};

export const getPurchaseOrderDisplayNumber = (
  purchaseOrder: PurchaseOrderIdentifiers,
) => purchaseOrder.project_po_number ?? purchaseOrder.po_number;

export const getPurchaseOrderNumberError = (
  error: unknown,
  fallback: string,
) => {
  const data = (
    error as
      | {
          data?: {
            project_po_number?: string | string[];
            detail?: string;
          };
        }
      | undefined
  )?.data;
  const numberError = data?.project_po_number;

  if (Array.isArray(numberError)) return numberError[0] || fallback;
  return numberError || data?.detail || fallback;
};
